/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, { useState } from 'react';
import {
  Paper,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import useStyle from './useStyle';
import newButton from '../../assets/img/iconos/newButton.svg';
import searchIcon from '../../assets/img/iconos/searchIcon.svg';
import ActionForm from './components/ActionForm/ActionForm';
import { Toaster } from '../../components';
import { defaultData } from './constants';

const ReadOnlyCommercialCategoryScreen = () => {
  const classes = useStyle();
  const [showAlert, setShowAlert] = useState(false);
  const [enteredFilter, setEnteredFilter] = useState('');

  const [defaultValues, setDefaultValues] = useState(defaultData);
  const [popUpAction, setPopUpAction] = useState({ open: false, title: '', data: null });

  const createNewCommercialCategory = () => {
    setDefaultValues(defaultData);
    setPopUpAction({
      open: true,
      title: 'Crear nueva categoría',
      data: null,
    });
  };

  return (

    <Paper className={classes.paper}>
      <>
        <div className={classes.root}>
          <div>
            <TextField
              className={classes.searchTextField}
              value={enteredFilter}
              onChange={(e) => setEnteredFilter(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={searchIcon} alt="searchIcon" style={{ paddingLeft: '10px' }} />
                  </InputAdornment>
                ),
                disableUnderline: true,
              }}
              placeholder="Buscar"
            />
            <Tooltip title="Crear nueva categoría" aria-label="Crear nueva categoría">
              <IconButton
                onClick={createNewCommercialCategory}
                style={{ fontSize: '20px', float: 'right' }}
                edge="end"
                size="small"
                classes={{ disabled: classes.disabled }}
              >
                <img src={newButton} alt="newButton" />
              </IconButton>
            </Tooltip>
          </div>
          <ActionForm
            open={popUpAction.open}
            data={popUpAction.data}
            title={popUpAction.title}
            defaultValues={defaultValues}
            onClose={() => {
              setPopUpAction({ open: false, title: '', data: null });
            }}
          />
        </div>
      </>
      <Toaster
        show={showAlert}
        type="error"
        text="Ha ocurrido un error, intente nuevamente."
        onClose={() => setShowAlert(false)}
      />
    </Paper>
  );
};

export default ReadOnlyCommercialCategoryScreen;
